export { default } from './Collapse';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Collapse/index.js
// module id = 245
// module chunks = 0